import { Row } from "reactstrap";
import CardStatistiqueItem from "./cardStatistiqueItem";
import { useQuery } from "react-query";
import { getVehicules } from "../../../Vehicules/services/vehiculeApi";
import { getInspections } from "../../../Inspections/services/inspectionApi";
import { getUsers } from "../../../Users/services/userApi";
import { getDemandeMateriels } from "../../../Materiels/services/materielApi";

const CardStatistique = () => {
    const { data: vehicles } = useQuery("vehicules", getVehicules);
    const { data: inspectData} = useQuery("inspections", getInspections);
    const { data: users } = useQuery("users", getUsers);
    const { data: demandeMaterials, isLoading, isError, error } = useQuery("demandes", getDemandeMateriels);
    console.log("--demandeMaterials--",demandeMaterials)

    const drivers = users?.filter(user => user.role?.name === "DRIVER");
    const inspections = inspectData?.filter(inspection => inspection.category !== "Incident");
    const incidents = inspectData?.filter(inspection => inspection.category === "Incident");

    const activeDriversCount = drivers?.filter(driver => driver?.status === "ACTIF").length || 0;
    const inactiveDriversCount = drivers?.filter(driver => driver?.status === "INACTIF").length || 0;
    const archivedDriversCount = drivers?.filter(driver => driver?.archived === true).length || 0;

    const inServiceVehiclesCount = vehicles?.filter(vehicle => vehicle?.statut === "En service").length || 0;
    const outOfServiceVehiclesCount = vehicles?.filter(vehicle => vehicle?.statut === "Hors service").length || 0;
    const archivedVehiclesCount = vehicles?.filter(vehicle => vehicle?.archived === true).length || 0

    const inspCiblee= inspections?.filter(inspection => inspection?.typeInspection?.includes("Ciblée")).length || 0;
    const inspComplete = inspections?.filter(inspection => inspection?.typeInspection?.includes("Compléte")).length || 0;

    const pendAskCount = demandeMaterials?.filter(inc => inc?.status?.includes("EN_COURS")).length || 0;
    const remAskCount = demandeMaterials?.filter(inc => inc?.status?.includes("REMISE")).length || 0;
    const newAskCount = demandeMaterials?.filter(inc => inc?.status?.includes("NOUVEAU")).length || 0;

    const statsData = [
        {
            title: "Véhicules",
            icon: "truck",
            url: "/vehicles",
            className: "text-info",
            counterStart: 0,
            counterEnd: vehicles?.length || "-",
            counterDuration: 4,
            stats: [
                { label: "Service", value: inServiceVehiclesCount || "0", align: "text-center" },
                { label: "Inactif", value: outOfServiceVehiclesCount || "0", align: "text-center" },
                { label: "Archivé", value: archivedVehiclesCount || "0", align: "text-left" }
            ],
        },
        {
            title: "Chauffeurs",
            icon: "user",
            className: "text-success",
            url: "/drivers",
            counterStart: 0,
            counterEnd: drivers?.length || "-",
            counterDuration: 4,
            stats: [
                { label: "Actif", value: activeDriversCount || "0", align: "text-left" },
                { label: "Inactif", value: inactiveDriversCount || "0", align: "text-left" },
                { label: "Archivé", value: archivedDriversCount || "0", align: "text-left" }
            ],
        },        
                
        {
            title: "Inspections",
            icon: "clipboard",
            url: "/inspections",
            className: "text-success",
            counterStart: 0,
            counterEnd: inspectData?.length || "-",
            counterDuration: 4,
            stats: [
                { label: "Ciblée", value: inspCiblee || "0", align: "text-left" },
                { label: "Compléte", value: inspComplete || "0", align: "text-center" },
                { label: "Incidents", value: incidents?.length || "0", align: "text-center" },
            ],
        },
        {
            title: "Demandes",
            icon: "alert-triangle",
            url: "/demandes-materiels",
            className: "text-danger",
            counterStart: 0,
            counterEnd: demandeMaterials?.length || "-",
            counterDuration: 4,
            stats: [
                { label: "Nouveau", value: newAskCount || "0", align: "text-left" },
                { label: "En cours", value: pendAskCount || "0", align: "text-left" },
                { label: "Remise", value: remAskCount || "0", align: "text-center" }
            ],
        },
    ];

    return (
        <Row>
            {statsData.map((card, index) => (
                <CardStatistiqueItem
                    key={index}
                    title={card.title}
                    icon={card.icon}
                    className={card.className}
                    url={card.url}
                    counterStart={card.counterStart}
                    counterEnd={card.counterEnd}
                    counterDuration={card.counterDuration}
                    stats={card.stats}
                />
            ))}
        </Row>
    );
};

export default CardStatistique;
